<template>
  <div class="org-section">
    <div class="grid grid--container">
      <FeatureGrid style="padding: 0; margin: 0">
        <FeatureCard
          title="Sophisticated member management tools for organizations"
          bg-color="#f2ba43"
          color="#fff"
        >
          <AccountMultipleIcon slot="icon" />
          <VText gutter-bottom>
            Organizations allow you to manage your team members and their access
            to your profiles. Add, remove and switch between profiles with ease.
            All under a single invoice.
          </VText>

          <Button
            slot="actions"
            to="/use-cases/organizations"
            color="gray800"
            variant="hard-shadow"
            >Learn more</Button
          >
        </FeatureCard>
        <FeatureCard
          title="Unlock advanced analytics with Pro+"
          bg-color="#c2d4a1"
          color="#fff"
        >
          <LineChartIcon slot="icon" />
          <VText gutter-bottom>
            We turn your analytics into actionable insights to help you make
            data driven decisions. Faster insights help convert your followers
            into customers.
          </VText>

          <Button
            slot="actions"
            to="/landing/advanced-analytics"
            color="gray800"
            variant="hard-shadow"
            >Learn more</Button
          >
        </FeatureCard>
      </FeatureGrid>
    </div>
  </div>
</template>

<script>
import {
  VText,
  Button,
  AccountMultipleIcon,
  LineChartIcon,
} from '@campsite-bio/component-lib';

import FeatureGrid from '@/components/features/feature-grid';
import FeatureCard from '@/components/features/feature-card';

export default {
  components: {
    VText,
    Button,
    FeatureGrid,
    FeatureCard,
    AccountMultipleIcon,
    LineChartIcon,
  },

  setup(props) {},
};
</script>

<style lang="scss" scoped>
.pro-section {
  padding-bottom: 4rem;
  padding-top: 3rem;
  text-align: center;

  @media (min-width: 992px) {
    padding-bottom: 8rem;
    padding-top: 7rem;
  }
}
</style>
